<template lang="html">
  <v-dialog
    v-model="opened"
    max-width="600"
    persistent
    :fullscreen="$vuetify.breakpoint.xsOnly"
    @keydown.esc="$emit('update:opened', false)"
  >
    <v-card>
      <v-card-title class="title pb-0">
        Add Webhook
        <v-spacer />
        <v-btn
          fab
          small
          class="error--text text-none my-0"
          flat
          @click="$emit('update:opened', false)"
        >
          <v-icon>clear</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="text-xs-left">
        <div class="text-xs-left mt-2">
          <span class="error--text">*</span>
          Hook URL
        </div>
        <v-text-field
          v-model="hookUrl"
          hide-details
          class="default-input"
          solo
          placeholder="Hook url"
        />

        <div class="text-xs-left mt-4">
          <span class="error--text">*</span>
          Hook type
        </div>
        <v-select
          type="text"
          :items="hookTypes"
          v-model="hookType"
          placeholder="Select hook type"
          solo
          class="default-input"
          required
        />
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn
          class="primary text-none"
          @click="addWebhook()"
          :disabled="isEmpty(hookUrl) || isEmpty(hookType)"
        >
          Add Webhook
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from 'moment';
import API from '@/api';
import { mapState, mapGetters } from 'vuex';
import isEmpty from 'lodash/isEmpty';

export default {
  name: 'AddWebhookDialog',
  props: {
    opened: {
      type: Boolean,
    },
  },
  data() {
    return {
      hookUrl: '',
      hookType: '',
      hookTypes: [
        'questionnaire_created',
        'questionnaire_submitted',
        'questionnaire_locked',
        'questionnaire_comment_added',
        'questionnaire_template_started',
        'document_uploaded',
        'document_deleted',
        'document_exported',
        'message_sent',
        'entity_info_changed',
        'client_info_changed',
        'client_added',
      ],
    };
  },
  computed: {},

  methods: {
    moment,
    isEmpty,

    async addWebhook() {
      try {
        const response = await API.integration.addWebhook({
          hookUrl: this.hookUrl,
          hookType: this.hookType,
        });

        this.$store.dispatch('application/setSuccessNotification', {
          message: 'Tag created!',
        });

        this.$emit('added-webhook');
        this.$emit('update:opened', false);

        this.hookUrl = '';
        this.hookType = '';
      } catch (e) {
        this.$store.dispatch('application/setErrorNotification', {
          message:
            'There was a problem adding the webhook. Please try again after refreshing the page.',
        });
      }
    },
  },
};
</script>

<style lang="postcss" scoped></style>
